export default function Row({ children, className = "mb-3 p-1", style = {} }) {
  return (
    <div className={`row ${className}`} style={style}>
      {children}
    </div>
  );
}
